import { render, staticRenderFns } from "./followRecords.vue?vue&type=template&id=0d426fc5&"
import script from "./followRecords.vue?vue&type=script&lang=js&"
export * from "./followRecords.vue?vue&type=script&lang=js&"
import style0 from "./followRecords.vue?vue&type=style&index=0&id=0d426fc5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports